import { Pageheader } from '@shared/Frontend/components/pageheader'
import React from 'react'

export const HomePage = () => (
  <Pageheader
    title="Welcome to the <span>Hoppinger Design System</span>"
    introduction="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex."
    image={{
      src: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-512x384.jpeg',
      alt: 'Northern lights',
      crops: [
        { width: 640, url: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-512x384.jpeg' },
        { width: 1280, url: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-1024x768.jpeg' },
        { width: 1920, url: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-1024x768.jpeg' },
        { width: 2880, url: 'https://giustoragev2.blob.core.windows.net/shoppinger/northern-lights-2048x1536.jpeg' },
      ],
    }}
    kind={'home'}
  />
)
